<template>
  <div class="received-resumes-list _approved">
      <div v-if="pending" class="page__columns-inner container-inner">
        <div class="page__main-col">
          <BasePreloader/>
        </div>
      </div>
      <div v-else-if="offers.length">
        <ResumeAccordionItem v-for="(offer, index) in offers"
                             :key="index"
                             class="received-offer">
          <div slot="title" class="account-received-resumes__tab-title ">
             <div class="received-offer__title">
              <div v-if="offer.photosVideos.length" class="received-offer__title-avatar">
                <video v-if="offer.photosVideos[0].ext && isVideoExt(offer.photosVideos[0])">
                  <source :src="offer.photosVideos[0].path"
                          :type="'video/'+offer.photosVideos[0].ext">
                  Your browser does not support the video tag.
                </video>
                <img v-else :src="offer.photosVideos[0].path" alt="">
              </div>
              <div class="received-offer__title-name">{{offer.first_name}}&nbsp;{{offer.second_name}}</div>
              <span class="__gray">({{age(offer.personal_data.birthday)}}&nbsp; {{$tReceived('years')}})</span>
            </div>
             <div class="account-received-resumes__tab-right">
                <div>
                  <span class="__gray">{{$tReceived('Offers count')}}</span>
                  <span>{{offer.interactions.length}}</span>
                </div>
              </div>
          </div>
          <div slot="content" class="resume-item__content">
            <div v-for="item in offer.interactions"
                 :key="item.id"
                 class="resume-item">
              <div class="resume-item__title">{{item.vacancy.title}}</div>
            <!--  <router-link-modified :to="{name: 'vacancy', params: {
                vacancyId: item.vacancy.slug,
                directionId: item.vacancy.category && (item.vacancy.category.direction_slug || item.vacancy.category.direction_id) || 'no-direction'
              }}" class="resume-item__title">
              </router-link-modified>-->

            <div class="resume-item__right">
              <div class="resume-item__step">
                <div class="resume-item__step-text">{{$tReceived('Stage')}}</div>
                <div class="resume-item__step-circle">
                  <span>{{item.step_information.step_number}}</span>
                  <div class="resume-item__step-tooltip">{{item.step_information.title}}</div>
                </div>
              </div>
              <div class="resume-item__timer">
                <div class="resume-item__timer-text">{{$tReceived('Time left')}}</div>
                <Timer v-if="item.time_for_step"
                       :endTime="item.time_for_step"
                       :responded="false"
                       :vacancy="item"
                       class="resume-item__timer _no-hover"/>
              </div>
                <div class="resume-item__date">
                  <span class="__gray">{{$tReceived('Received')}}</span>
                  {{item.created_at}}
                </div>
              <router-link-modified :to="{ name: 'account-interaction', params: { id: item.id }}"
                           class="base-btn base-btn--outline-grey">
                <span class="base-btn__text">{{$tReceived('More details')}}</span>
              </router-link-modified>
              </div>

            </div>
          </div>

        </ResumeAccordionItem>
      </div>
      <div v-else>{{$tReceived('Offers not found')}}</div>
  </div>
</template>

<script>
  import {http} from "../axios"
  import ResumeAccordionItem from "../components/ResumeAccordionItem";
  import Timer from "./Timer";
  // import Pagination from "../components/Pagination";


  export default {
    name: 'ReceivedOffersList',
    components: {
      ResumeAccordionItem,
      Timer
      // Pagination
    },
    data() {
      return {
        pending: false,
        offers: [],
        activeTab: 0,
        queryParamsNames: ['page','order_by'],
        queryNamePage: 'page',
        total: 0,
        perPage: 0,
      }
    },
    computed: {
      queryParams() {
        const params = {}

        for (let name of this.queryParamsNames) {
          let value = this.$route.query[name]
          if (value) {
            params[name] = value
          }
        }
        return params
      },

      page() {
        return this.$route.query[this.queryNamePage] || 1
      },
      pagesCount() {
        return Math.ceil(this.total / this.perPage) || 0
      }
    },
    methods: {
      getVacanciesList() {
        this.pending = true

        return http.get('/api/cabinet/approved-resumes').then(({data}) => {
          this.offers = data.data
        }).finally(()=>{ this.pending = false})
      },
      age(date) {
        if(date) {
          const currentYear = new Date().getFullYear()
          return currentYear - (+date.slice(-4))
        }
      },
      onSortInput(value) {
        this.$router.push({query: {...this.$route.query, order_by: value}})
      },
      isVideoExt(file) {
        return ['mp4', 'webm'].includes(file.ext)
      }
    },
    created() {
      this.getVacanciesList()
    },
    watch: {
      $route() {
        this.getVacanciesList()
      }
    }
  }
</script>

<style lang="less">

</style>
